import { Instagram, Facebook, MapPin, Phone, MessageCircle } from "lucide-react";
import { NAV_LINKS, CLINIC } from "../data/clinic";
import { scrollToId } from "../lib/scroll";

export const Footer = () => (
  <footer data-testid="footer" className="bg-sa-espresso pt-20 pb-10">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid md:grid-cols-[1.5fr_1fr_1fr] gap-12 pb-14 border-b border-sa-cream/10">
        <div>
          <p className="font-display text-3xl text-sa-cream mb-4">
            MS<span className="italic text-sa-bronze"> Pet Hospital</span>
          </p>
          <p className="font-body text-base text-sa-cream/60 max-w-xs leading-relaxed">
            A 24/7 veterinary hospital in DHA Phase 2, Islamabad — compassionate
            emergency and everyday care for cats, dogs and birds.
          </p>
        </div>

        <div>
          <h4 className="font-body text-xs uppercase tracking-[0.2em] text-sa-bronze font-semibold mb-5">
            Explore
          </h4>
          <ul className="space-y-3">
            {NAV_LINKS.map((link) => (
              <li key={link.href}>
                <button
                  onClick={() => scrollToId(link.href)}
                  data-testid={`footer-link-${link.label.toLowerCase()}`}
                  className="font-body text-sm text-sa-cream/70 hover:text-sa-cream transition-colors"
                >
                  {link.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-body text-xs uppercase tracking-[0.2em] text-sa-bronze font-semibold mb-5">
            Get in touch
          </h4>
          <ul className="space-y-3">
            <li>
              <a
                href={`tel:${CLINIC.phoneTel}`}
                className="flex items-center gap-2 font-body text-sm text-sa-cream/70 hover:text-sa-cream transition-colors"
              >
                <Phone className="w-4 h-4 text-sa-bronze" />
                {CLINIC.phoneDisplay}
              </a>
            </li>
            <li className="flex items-start gap-2 font-body text-sm text-sa-cream/70">
              <MapPin className="w-4 h-4 text-sa-bronze mt-0.5 shrink-0" />
              <span>{CLINIC.address.full}</span>
            </li>
          </ul>
          <div className="flex gap-3 mt-6">
            <button
              onClick={() => scrollToId("#contact")}
              aria-label="Instagram — profile coming soon"
              title="Profile coming soon"
              data-testid="footer-social-instagram"
              className="w-10 h-10 rounded-full border border-sa-cream/20 flex items-center justify-center text-sa-cream/70 hover:bg-sa-bronze hover:border-sa-bronze hover:text-sa-cream transition-colors"
            >
              <Instagram className="w-4 h-4" />
            </button>
            <button
              onClick={() => scrollToId("#contact")}
              aria-label="Facebook — profile coming soon"
              title="Profile coming soon"
              data-testid="footer-social-facebook"
              className="w-10 h-10 rounded-full border border-sa-cream/20 flex items-center justify-center text-sa-cream/70 hover:bg-sa-bronze hover:border-sa-bronze hover:text-sa-cream transition-colors"
            >
              <Facebook className="w-4 h-4" />
            </button>
            <a
              href={CLINIC.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Chat on WhatsApp"
              data-testid="footer-social-whatsapp"
              className="w-10 h-10 rounded-full border border-sa-cream/20 flex items-center justify-center text-sa-cream/70 hover:bg-sa-bronze hover:border-sa-bronze hover:text-sa-cream transition-colors"
            >
              <MessageCircle className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>

      <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-body text-sm text-sa-cream/50">
          © {new Date().getFullYear()} MS Pet Hospital. All rights reserved.
        </p>
        <p className="font-body text-sm text-sa-cream/50">
          Open 24 hours · 7 days a week
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
